<mat-table [dataSource]="vehicles()">
	<ng-container matColumnDef="vehicleName">
		<mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index" class="text-small"> {{ element.name }} </mat-cell>
	</ng-container>
	<ng-container matColumnDef="vehicleCapacity">
		<mat-header-cell *matHeaderCellDef>Pojemność</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index" class="text-small"> {{ element.capacity }} </mat-cell>
	</ng-container>
	<ng-container matColumnDef="vehicleFreeSeats">
		<mat-header-cell *matHeaderCellDef>Wolne miejsca</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index" class="text-small">
			{{ element.capacity - element.crew - element.takenSeats }}
		</mat-cell>
	</ng-container>
	<ng-container matColumnDef="vehicleCrew">
		<mat-header-cell *matHeaderCellDef>Załoga</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index">
			<app-vehicle-crew-row
				class="w-100"
				(newCrewEvent)="calculateFreeSeats($event, element)"
				[vehicle]="element"
			></app-vehicle-crew-row>
		</mat-cell>
	</ng-container>
	<ng-container matColumnDef="vehicleActions">
		<mat-header-cell *matHeaderCellDef>Akcja</mat-header-cell>
		<mat-cell *matCellDef="let element; let i = index" class="d-flex gap-2">
			@if (element.inUse) {
				<button mat-raised-button disabled color="primary">W użyciu</button>
			} @else {
				<button mat-raised-button color="primary" (click)="useVehicle(element)">Użyj</button>
			}
			<button mat-raised-button color="warn" (click)="unselectVehicle(element)">Usuń</button>
			<button
				mat-icon-button
				(click)="toggleVehicleVisibility(element)"
				[matTooltip]="
					element.visible ? HIDE_ROUTE_FOR_THIS_VEHICLE_MESSAGE : SHOW_ROUTE_FOR_THIS_VEHICLE_MESSAGE
				"
			>
				@if (element.visible) {
					<i class="fas fa-eye-slash"></i>
				} @else {
					<i class="fas fa-eye"></i>
				}
			</button>
		</mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
	<mat-row *matRowDef="let row; columns: tableColumns"></mat-row>
</mat-table>
